/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var e;!function(e){e[e.Recreate_Symbol=0]="Recreate_Symbol",e[e.Recreate_Graphics=1]="Recreate_Graphics",e[e.Fast_Update=2]="Fast_Update"}(e||(e={}));export{e as ApplyRendererDiffResult};
